import axios from "axios";

export type LoggingRequest = {
    messageTemplate: string,
    messageParams: Array<string>
}

export default class LoggingService {
    logErrorMessage: (
        request: LoggingRequest,
        hostname: string
    ) => Promise<number> = async (request, hostname) => {
    const response = await axios.post(
      `https://${hostname}/api/Logging/LogError/`,
      {
        ...request,
      }
    );
    return { ...response.data };
  };

    logInfoMessage: (
        request: LoggingRequest,
        hostname: string
    ) => Promise<number> = async (request, hostname) => {
    const response = await axios.post(
      `https://${hostname}/api/Logging/LogInformation/`,
      {
        ...request,
      }
    );
    return { ...response.data };
  };
}